import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";

// Iter312: Hinweis im Lohnlauf-Formular, wenn unbezahlte Absenzen im Monat noch nicht genehmigt sind
export function UnpaidAbsenceWarning({ companyId, employeeId, period, onApproved }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    if (!companyId || !employeeId || !period || period.length < 7) { setData(null); return; }
    try {
      const r = await apiClient.get(`/companies/${companyId}/absences/unpaid-pending`, { params: { employee_id: employeeId, period } });
      setData(r.data);
    } catch { setData(null); }
  };

  // eslint-disable-next-line
  useEffect(() => { load(); }, [companyId, employeeId, period]);

  const w = data?.warnings?.[0];
  if (!w) return null;

  const approveAll = async () => {
    setBusy(true);
    try {
      for (const a of w.absences) await apiClient.post(`/companies/${companyId}/absences/${a.absence_id}/approve`);
      toast.success(`${w.absences.length} unbezahlte Absenz(en) genehmigt – Kürzung wird im Lohnlauf berücksichtigt`);
      await load();
      onApproved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Genehmigung fehlgeschlagen");
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-2 flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid="unpaid-absence-warning">
      <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="font-medium" data-testid="unpaid-absence-warning-text">{w.message}</p>
        <p className="text-amber-800/80 mt-0.5">Nach Genehmigung wird der Fixlohn um {w.days}/30 gekürzt (30-Tage-Methode).</p>
      </div>
      <Button type="button" size="sm" variant="outline" className="border-amber-400 text-amber-900 h-7" disabled={busy} onClick={approveAll} data-testid="unpaid-absence-approve-button">
        {busy ? "…" : "Jetzt genehmigen"}
      </Button>
    </div>
  );
}
